<template lang="html">
  <ol class="app-footer">
    <li class="app-footer-item copyright">© {{ appName }}</li>
    <li class="app-footer-item">
      <a :href="supportMailTo">contact</a>
    </li>
    <li class="app-footer-item">
      <RemoteLink href="https://github.com/mhluska/blackjack-simulator"
        >blackjack-simulator</RemoteLink
      >
    </li>
  </ol>
</template>

<script>
import { appName } from '@/constants';
import { supportMailTo } from '@/constants';
import RemoteLink from '@/components/RemoteLink';

export default {
  name: 'AppFooter',

  components: {
    RemoteLink,
  },

  data() {
    return {
      appName,
      supportMailTo,
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';
@import '@/styles/mixins/app-width';

.app-footer {
  @include unstyled-list;
  @include app-width;

  // HACK: Hide this on small heights until we figure out an overflow issue
  // with narrow heights (blue background doesn't fill extra space).
  display: none;

  margin-top: map-get($app, 'spacing');
  font-size: 0.8em;
  justify-content: center;
  opacity: 0.7;
  width: 100%;
  height: map-get($app, 'spacing') * 2;
}

.copyright {
}

.app-footer-item {
  margin-right: 1em;

  &:last-child {
    margin-right: 0;
  }
}

a {
  color: inherit;
  text-decoration: none;
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .app-footer {
    display: flex;
  }
}
</style>
